import { OnboardingLayout } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// Layout for the /onboarding/* routes (SELF-138): holds on auth, gates on the
// essentials_onboarding flag, and renders an <Outlet/> for the child pages.
export const Route = createFileRoute('/onboarding')({
  component: OnboardingLayout,
});
